<template>
  <div id="layout-wrapper">
    <HeaderComponent />
    <main>
      <RouterView v-slot="{ Component }">
        <component
          :is="Component"
          :key="$route.path"
          @vue:mounted="initReveal"
        />
      </RouterView>
    </main>
    <FooterComponent />
  </div>
</template>

<script>
import { RouterView } from 'vue-router';
import HeaderComponent from './components/HeaderComponent.vue';
import FooterComponent from './components/FooterComponent.vue';

export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent,
    RouterView,
  },
  data() {
    return {
      observer: null, // Store observer to clean it up later
    };
  },
  methods: {
    initReveal() {
      // Disconnect existing observer if it exists from previous page
      if (this.observer) this.observer.disconnect();

      setTimeout(() => {
        const observerOptions = {
          threshold: 0.1,
          rootMargin: '0px 0px -50px 0px',
        };

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            // Safety check: ensure target and parent still exist
            if (entry.isIntersecting && entry.target) {
              entry.target.classList.add('active');
              this.observer.unobserve(entry.target);
            }
          });
        }, observerOptions);

        const revealElements = document.querySelectorAll('.reveal');
        revealElements.forEach((el) => {
          if (el) this.observer.observe(el);
        });
      }, 200); // Slightly longer delay for stability
    },
  },
  // Clean up before navigating away to prevent memory leaks/crashes
  beforeUnmount() {
    if (this.observer) this.observer.disconnect();
  },
};
</script>

<style>
/* Maintain your existing styles */
main {
  padding-top: 80px;
  min-height: 80vh; /* Keeps footer pushed down */
}

@keyframes fadeInUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.animate-up {
  animation: fadeInUp 0.8s ease forwards;
  opacity: 0;
}

/* Styles for the Intersection Observer '.reveal' elements */
.reveal {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease-out;
}

.reveal.active {
  opacity: 1;
  transform: translateY(0);
}

.delay-1 {
  animation-delay: 0.2s;
  transition-delay: 0.2s;
}
.delay-2 {
  animation-delay: 0.4s;
  transition-delay: 0.4s;
}
.delay-3 {
  animation-delay: 0.6s;
  transition-delay: 0.6s;
}

body {
  margin: 0;
  font-family: 'Inter', sans-serif;
  overflow-x: hidden;
}
</style>
